import React from "react";

function Refund_Policy() {
  return (
    <div className="bg-gray-50 text-gray-900 min-h-screen flex flex-col">
      {/* Hero Section */}
      <header className="relative bg-gradient-to-r from-blue-500 to-purple-600 text-white text-center py-10 px-6 shadow-lg mt-[70px]">
        <h1 className="text-3xl md:text-5xl font-extrabold tracking-wide">Refund/Cancellation Policy</h1>
        <p className="text-xl mt-3 max-w-2xl mx-auto"> We strive to provide excellent services. However, if you are not
          satisfied, you may be eligible for a refund under the following conditions.</p>
        <div className="!absolute inset-0 bg-opacity-20 bg-black"></div>
      </header>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-lg mt-10">
        <h2 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]">Refund Policy</h2>
        <p className="text-sm leading-relaxed text-[#2e3d49]">Thank you for buying our courses. We ensure that our users have a rewarding experience while they

discover,

assess, and purchase our courses, whether it may be instructor-led or self-paced training or classroom

training.</p><br/>
<p className="text-sm leading-relaxed text-[#2e3d49]">As with any online purchase experience, there are terms and conditions that govern the Refund Policy.

        When

        you buy a training course on </p><br/>
        <a href="https://yslearn.in/" target="_blank" style={{color:"blue"}} rel="noreferrer"><strong>www.yslearn.in</strong></a>
        <p className="text-sm leading-relaxed text-[#2e3d49]"> you agree to our Privacy Policy, Terms of Use, and refund policy.</p><br/>
        <p className="text-sm leading-relaxed text-[#2e3d49]">Our refund policy is as follows:</p>
        <h2 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]">Cancellation & Refunds: Self Paced Learning:-</h2>
        <h4 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]"><em>For Self Placed Learning:</em></h4>
        <p className="text-sm leading-relaxed text-[#2e3d49]"><strong>No refunds. </strong>All payments under this purchase will be irrevocable, non-refundable, and

        non-creditable.</p><br/>
        <h2 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]"><em>For Instructor Led Online Training:</em></h2>
        <p className="text-sm leading-relaxed text-[#2e3d49]"> <strong>No Refunds.</strong> There will be no refunds whatsoever for any courses.</p>
        <h4 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]"><em>Cancellation &amp; Refunds: Classroom Training:</em></h4>
        <p className="text-sm leading-relaxed text-[#2e3d49]"><strong>No Refunds.</strong> Payments referred to herein shall not be refundable under any circumstances.

        All

        payments under this purchase will be irrevocable, non-refundable, and non-creditable.</p><br/>
        <p className="text-sm leading-relaxed text-[#2e3d49]">yslearn.in reserves the right to postpone/cancel an event, or change the location of an event

        because of insufficient enrollments, instructor illness, or force majeure events (like floods,

        earthquakes,

        political instability, etc)</p><br/>
        <p className="text-sm leading-relaxed text-[#2e3d49]">In case yslearn.in cancels an event, a 100% refund will be paid to the delegate.</p>
        <h4 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]"><em>Refunds: Duplicate payment</em></h4>
        <p className="text-sm leading-relaxed text-[#2e3d49]">In case yslearn.in cancels an event, a 100% refund will be paid to the delegate.</p>
        <p className="text-sm leading-relaxed text-[#2e3d49]">Refunds of the duplicate payment made by the delegate will be processed via the same source (original

method

of payment) in 7 to 10 working days post intimation by the customer.</p><br/>
<p className="text-sm leading-relaxed text-[#2e3d49]"><strong>Note:</strong>

        All refunds will be processed within 7-10 working days after the refund request is approved by Smik

        Systems (OPC) Pvt Ltd.</p>
</div>

      
    </div>
  );
}

export default Refund_Policy;
